"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.languagesList = exports.Languages = void 0;
const values_1 = __importDefault(require("lodash/values"));
var Languages;
(function (Languages) {
    Languages["EN"] = "en";
    Languages["RU"] = "ru";
    Languages["UZ"] = "uz";
    Languages["KZ"] = "kz";
    Languages["CN"] = "cn";
    Languages["ZH"] = "zh";
})(Languages || (exports.Languages = Languages = {}));
exports.languagesList = (0, values_1.default)(Languages);
//# sourceMappingURL=languages.js.map